<template>
	<div class="flex w-full flex-col">
		<h2>What's included in a carbar subscription?</h2>
		<TickList :items="items" class="text-lg lg:space-y-1" />
	</div>
	<TermsAndConditions class="mt-6" :is-full-width="false">
		* Subject to fair wear and tear, taking into account the car's age and
		mileage and covering overall condition.
		<CarbarLink
			href="/terms-and-conditions/car-subscription"
			target="_blank"
			text="Terms and conditions"
			class="text-xsm"
		/>
		apply.
	</TermsAndConditions>
</template>

<script setup>
import TickList from '@/components/lists/TickList.vue'
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'

const items = [
	{
		label: 'Govt fees and charges',
	},
	{
		label: 'Mechanical faults',
	},
	{
		label: 'Worn tyres and batteries*',
	},
	{
		label: 'Routine servicing and maintenance',
	},
	{
		label: 'Vehicle registration',
	},
	{
		label: '24/7 Roadside Assistance Australia-wide',
	},
	{
		label: 'Comprehensive insurance',
	},
]
</script>
